import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import {useSiteSettingsContext} from "@/hooks/useSiteSettingsContext";
import { getDataClient } from "@/lib/dataClient";

/**
 * Oturum süresi yönetimi — site ayarlarındaki sessionTimeoutMin değerine göre
 * belirli bir süre hareketsiz kalan kullanıcıyı otomatik çıkış yapar.
 */
export default function SessionManager() {
  const { user } = useAuth();
  const { settings } = useSiteSettingsContext();
  const navigate = useNavigate();
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const userRef = useRef(user);
  userRef.current = user;

  useEffect(() => {
    if (!user) return;

    const minutes = Number(settings.sessionTimeoutMin) > 0 ? Number(settings.sessionTimeoutMin) : 60;
    const ms = minutes * 60 * 1000;

    const reset = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(async () => {
        try {
          await getDataClient().auth.signOut();
        } finally {
          navigate("/", { replace: true });
        }
      }, ms);
    };

    const events = ["mousedown", "keydown", "touchstart", "scroll"];
    events.forEach((ev) => window.addEventListener(ev, reset, { passive: true }));
    reset();

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach((ev) => window.removeEventListener(ev, reset));
    };
  }, [user, settings.sessionTimeoutMin, navigate]);

  return null;
}